/**
 * @param 1:brand → nombre de la marca
 * @example brands: veci, logitravel, partnerships, partnershipsUniversalMusic, partnershipsPortaventura, partnershipsHolidayguru, smy, smyPassengy.
 * @param 2:ComponenteName → nombre del componente (DestinationCard)
 * @param 3:Device → Desktop/Mobile
 * @param 4:nameConst → nombre de la constante, como el componente pero camelcase (destinationCard)
 */ import { ThemeId } from "../../../../../../../styles/types/theme.js";
import veciAddRoomStyles from "./styles/veci.js";
const addRoomThemes = {
    [ThemeId.veci]: veciAddRoomStyles
};
export default addRoomThemes;

//# sourceMappingURL=index.js.map